import routes from '@tabeeb/routes'
import { RootState } from '@tabeeb/store'

export const getIsContentReadonly = (state: RootState) =>
  state.router.location.pathname.startsWith(routes.readonlyContent)
